module.exports = __webpack_public_path__ + "img/turn-left.b8e0aa43.svg";